import React, { Component, Fragment } from 'react';

import './App.css';
import "tabler-react/dist/Tabler.css";

import { HashRouter as Router, Switch, Route} from 'react-router-dom';

import Header from './main/Header';
import Content from './main/Content';
import Footer from './main/Footer';

import Home from './pages/Home';
import Leistungen from './pages/Leistungen';
import CurriculumVitae from './pages/CurriculumVitae';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Geschaeftsbedingungen from './pages/Geschaeftsbedingungen';

import {
  Page,
} from "tabler-react";


class ScrollToTopOnMount extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return null;
  }
}



class App extends Component<{}, {}>{
  render() {
    return (
      <Page className="App">
        <Router>
          <Header name='Header' />
          <Content>
            <Switch>
              <Route exact path='/' component={() => (<Fragment><ScrollToTopOnMount/><Home /></Fragment>)} />
              <Route exact path='/Leistungen' component={() => (<Fragment><ScrollToTopOnMount/><Leistungen /></Fragment>)} />
              <Route exact path='/Curriculum Vitae' component={() => (<Fragment><ScrollToTopOnMount/><CurriculumVitae /></Fragment>)} />
              <Route exact path='/Impressum' component={() => (<Fragment><ScrollToTopOnMount/><Impressum /></Fragment>)} />
              <Route exact path='/Datenschutz' component={() => (<Fragment><ScrollToTopOnMount/><Datenschutz /></Fragment>)} />
              <Route exact path='/Geschäftsbedingungen' component={() => (<Fragment><ScrollToTopOnMount/><Geschaeftsbedingungen /></Fragment>)} />
            </Switch>
          </Content>
          <Footer />
        </Router>
      </Page>
    )
  }
}


export default App;
